import { Table } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.ul`
  margin-top: 20px;
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #444;
    gap: 8px;

    & + li {
      margin-top: 15px;
    }

    .info {
      display: flex;
      flex-direction: column;
      flex: 1;

      div {
        display: flex;
        justify-content: space-between;
      }

      .relation__product {
        width: fit-content;
      }
    }

    .relation__product {
      background: transparent;
      border: none;
      color: #329bfc;
      border: 1px solid transparent;
      padding: 2px;
      border-radius: 4px;

      &:hover {
        border-color: #329bfc;
      }
    }
  }

  .icons {
    display: flex;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  display: flex;
  flex-direction: column;
  max-width: 230px;

  flex: 1;
  align-items: flex-start;

  p {
    font-weight: 400;
    font-size: 10px;
    color: #9e9e9e;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (min-width: 425) {
      width: 225px;
    }
  }

  div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;

    p {
      font-weight: 400;
      font-size: 10px;
      color: #9e9e9e;
      width: auto;
      margin: 0;
    }

    button {
      border: 0;
      background: transparent;
      margin-left: 5px;
      cursor: pointer;

      p {
        font-weight: 400;
        font-size: 10px;
        color: #e57878;
      }
    }
  }
`;

export const Preview = styled.div<{ src: string }>`
  width: 36px;
  height: 36px;
  border-radius: 5px;
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  margin-right: 10px;
`;

export const ModalContainer = styled.div`
  width: 250px;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 4px;

  h1 {
    font-weight: 700;
    font-size: 24px;
    color: #263238;
    padding-top: 10px;
    text-align: center;
  }

  .closeModal {
    position: absolute;
    top: 12px;
    right: 12px;
    border: none;
    font-size: 20px;
    color: #555;
    background: transparent;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    transition: 0.3s;

    :hover {
      background: red;
      color: white;
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
    padding: 12px;
  }
`;

export const TableCell = styled.tr`
  font-size: 13px;
  text-align: center;

  &:last-child {
    margin-left: -25px;
  }
`;

export const TableHeader = styled.thead`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: 80px minmax(250px, 1fr) 100px 161.2px 40px;
  padding: 16px;
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;

  ${TableCell} {
    &:nth-child(1) {
      width: 70px;
    }

    &:nth-child(2) {
      width: 250px;
      text-align: left;
    }

    &:nth-child(3) {
      width: 100px;
    }

    &:nth-child(4) {
      width: 165px;
    }

    &:nth-child(5) {
      width: 50px;
    }
  }
`;

export const TableBody = styled.tbody`
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #101d40;
`;

export const CustomTable = styled(Table)`
  border-collapse: initial;
  font-family: Sora, sans-serif;
`;
